export default {
  produtos: {
    arvoreProdutos: {
      quantidadeItens: 'Nenhum item | {quantidade} item | {quantidade} itens',
    },
  },
}
